import React from 'react';
import PropTypes from 'prop-types';

const Filters = ({ data, toggleFilter, toggleAllFilters }) => (
  <form className="interactive-map-module__filters">
    <h3 className="interactive-map-module__filters-title">Show</h3>
    <ul className="interactive-map-module__filters-list">
      <li>
        <label className="interactive-map-module__filter">
          <input
            type="checkbox"
            checked={data.every(filter => filter.selected)}
            onChange={() =>
              toggleAllFilters(!data.every(filter => filter.selected))
            }
          />
          <span className="interactive-map-module__filter-checkmark"></span>
          All
        </label>
      </li>
      {data.map(filter => (
        <li key={filter.filterId}>
          <label
            htmlFor={filter.filterId}
            className="interactive-map-module__filter"
          >
            <input
              type="checkbox"
              name={filter.filterId}
              id={filter.filterId}
              checked={filter.selected}
              onChange={() => toggleFilter(filter.filterId)}
            />
            <span className="interactive-map-module__filter-checkmark"></span>
            {filter.name}
            <img src={filter.flagImage.icon} alt={filter.name} />
          </label>
        </li>
      ))}
    </ul>
  </form>
);

Filters.propTypes = {
  data: PropTypes.array.isRequired,
  toggleFilter: PropTypes.func.isRequired,
  toggleAllFilters: PropTypes.func.isRequired
};

export default Filters;
